import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1e3b3081"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "news-container"
};
const _hoisted_2 = {
  class: "section"
};
const _hoisted_3 = {
  class: "body-container"
};
const _hoisted_4 = {
  class: "notice-box"
};
const _hoisted_5 = {
  class: "page-title"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-bottom": "-8px"
  },
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#0044EC"
  }
}, "新闻"), /*#__PURE__*/_createTextVNode("动态 ")], -1));

const _hoisted_7 = ["href"];

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 更多");

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "16",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/ef8515601c4445a596596889eea52307.png",
  alt: ""
}, null, -1));

const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = {
  class: "content"
};
const _hoisted_12 = {
  class: "classify-box"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/9ccdfbd7d1194e1a8d2c6d536242ded4.png"
}, null, -1));

const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = ["onClick"];

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/9ccdfbd7d1194e1a8d2c6d536242ded4.png"
}, null, -1));

const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  key: 0,
  class: "news-list"
};
const _hoisted_19 = ["href"];
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "main-notice-content"
};
const _hoisted_22 = ["title"];
const _hoisted_23 = {
  class: "title"
};
const _hoisted_24 = {
  key: 1,
  class: "notice-container"
};
const _hoisted_25 = {
  class: "notice-title text-overflow"
};
const _hoisted_26 = ["innerHTML"];
const _hoisted_27 = {
  class: "notice-bottom"
};
const _hoisted_28 = {
  class: "date"
};
const _hoisted_29 = {
  class: "dd"
};
const _hoisted_30 = ["href"];

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/0975209b77ad4af2bf54c359ba4c4121.png",
  width: "50",
  class: "default"
}, null, -1));

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/457626b0f8634cc2a75974aa9402413b.png",
  width: "50",
  class: "hover"
}, null, -1));

const _hoisted_33 = [_hoisted_31, _hoisted_32];
const _hoisted_34 = ["href"];
const _hoisted_35 = {
  class: "notice-top"
};
const _hoisted_36 = ["title"];
const _hoisted_37 = ["innerHTML"];
const _hoisted_38 = ["href"];

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "24",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/d94c7f21252a4df3b331a4ee092217e4.png",
  alt: ""
}, null, -1));

const _hoisted_40 = [_hoisted_39];
const _hoisted_41 = {
  class: "card-item-bottom"
};
const _hoisted_42 = {
  class: "date"
};
const _hoisted_43 = {
  class: "dd"
};
const _hoisted_44 = ["href"];

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/0975209b77ad4af2bf54c359ba4c4121.png",
  width: "50",
  class: "default"
}, null, -1));

const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/457626b0f8634cc2a75974aa9402413b.png",
  width: "50",
  class: "hover"
}, null, -1));

const _hoisted_47 = [_hoisted_45, _hoisted_46];
const _hoisted_48 = {
  key: 1,
  class: "no-data"
};

const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/86150a57b9044e61b2a810ccbc59cc4a.png"
}, null, -1));

const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1));

const _hoisted_51 = [_hoisted_49, _hoisted_50];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("a", {
    href: `/notice.html?name=${$props.menu.menu_name}&menuId=${$props.menu.id}`,
    class: "more"
  }, _hoisted_10, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [$data.classifyList.length > 5 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "show-more-btn",
    onClick: _cache[0] || (_cache[0] = $event => $options.scroll('left'))
  }, _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden']),
    ref: "category"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classifyList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.classifyId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_15);
  }), 128))], 2), $data.classifyList.length > 5 ? (_openBlock(), _createElementBlock("span", {
    key: 1,
    class: "show-more-btn left",
    onClick: _cache[1] || (_cache[1] = $event => $options.scroll('right'))
  }, _hoisted_17)) : _createCommentVNode("", true)]), $data.mainRecommendNews ? (_openBlock(), _createElementBlock("div", _hoisted_18, [$data.mainRecommendNews ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["main-bg", $data.mainRecommendNews && $data.mainRecommendNews.news_cover_url ? 'main-bgUrl' : 'main-notice-bg'])
  }, [$data.mainRecommendNews ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "main-notice",
    target: "_self",
    href: `/noticeDetail.html?type=1&id=${$data.mainRecommendNews.id}&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`
  }, [$data.mainRecommendNews.news_cover_url ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("img", {
    src: $data.mainRecommendNews ? $data.mainRecommendNews.news_cover_url : ''
  }, null, 8, _hoisted_20), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
    class: "main-notice-top",
    title: $data.mainRecommendNews.news_name
  }, [_createElementVNode("div", _hoisted_23, _toDisplayString($data.mainRecommendNews.news_name), 1)], 8, _hoisted_22)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString($data.mainRecommendNews.news_name), 1), _createElementVNode("p", {
    class: "notice-intro text-overflow-third",
    innerHTML: _ctx.$utils.getContentText($data.mainRecommendNews.context)
  }, null, 8, _hoisted_26), _createElementVNode("div", _hoisted_27, [_createElementVNode("p", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$utils.formatDate($data.mainRecommendNews.publish_time, "DD")), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$utils.formatDate($data.mainRecommendNews.publish_time, "YYYY-MM")), 1)])])]))], 8, _hoisted_19)) : _createCommentVNode("", true), _createElementVNode("a", {
    class: "detaild-btn",
    target: "_self",
    href: `/noticeDetail.html?type=1&id=${$data.mainRecommendNews.id}&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`
  }, _hoisted_33, 8, _hoisted_30)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["notice-center", $data.newsList.length == 1 ? 'notice-one' : $data.newsList.length == 2 ? 'notice-two' : $data.newsList.length == 3 ? 'notice-three' : $data.newsList.length == 4 ? 'notice-four' : 'notice-five'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      class: "notice-center-item",
      key: index,
      href: `/noticeDetail.html?type=1&id=${item.id}&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`
    }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
      class: "notice-center-title text-overflow-one",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_36), _createElementVNode("p", {
      class: "new-intro text-overflow-one",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_37), _createElementVNode("a", {
      href: `/noticeDetail.html?type=1&id=${item.id}&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`,
      class: "more"
    }, _hoisted_40, 8, _hoisted_38)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("p", _hoisted_42, [_createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, "DD")), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, "YYYY-MM")), 1)])]), _createElementVNode("a", {
      href: `/noticeDetail.html?type=1&id=${item.id}&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`,
      class: "new-more"
    }, _hoisted_47, 8, _hoisted_44)], 8, _hoisted_34);
  }), 128))], 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_51))])])])])]);
}